/* eslint-disable camelcase, react/no-danger */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import moment from 'moment';
import { Button } from '@storable/canaveral-components';
import styles from './styles.scss';

const propTypes = {
  notification: PropTypes.shape({
    body: PropTypes.string.isRequired,
    posted_on: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {};

const EchoInboxItem = ({ notification }) => {
  const [showBody, setShowBody] = useState(false);
  const toggleBody = () => setShowBody(!showBody);

  const { body, posted_on, title, summary } = notification;
  const postedOn = moment(posted_on).format('M/D/YY');

  return (
    <div className={styles.container}>
      <h5 className={styles.header}>
        <span>{title}</span>
        <Button
          type="button"
          onClick={toggleBody}
          icon="select-arrow"
          label="Toggle Notification Body"
          context="bare"
          size="lg"
          className={cx(styles.button, { [styles.openToggle]: showBody })}
          data-testid="toggle-notification-body"
        />
      </h5>
      <p>Posted on: {postedOn}</p>
      <span>{summary}</span>
      {showBody && (
        <div dangerouslySetInnerHTML={{ __html: body }} />
      )}
    </div>
  );
};

EchoInboxItem.propTypes = propTypes;
EchoInboxItem.defaultProps = defaultProps;

export default EchoInboxItem;
